/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { User } from './User.js';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User.js';

/**
 * 
 * @export
 * @interface GetUsersResponse
 */
export interface GetUsersResponse {
    /**
     * 
     * @type {Array<User>}
     * @memberof GetUsersResponse
     */
    data?: Array<User>;
    /**
     * 
     * @type {number}
     * @memberof GetUsersResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetUsersResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetUsersResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetUsersResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetUsersResponse interface.
 */
export function instanceOfGetUsersResponse(value: object): boolean {
    return true;
}

export function GetUsersResponseFromJSON(json: any): GetUsersResponse {
    return GetUsersResponseFromJSONTyped(json, false);
}

export function GetUsersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUsersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(UserFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetUsersResponseToJSON(value?: GetUsersResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(UserToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

